import { CalloutCard, Frame, Page } from "@shopify/polaris";
import React, { ReactNodeArray, Suspense, useContext, useEffect, useState } from "react";
import { useToken } from "src/components/authentication/TokenProvider";
import { Loading } from "src/components/Loading";
import { ContextUser } from "src/context/ContextUser";
import { createRoutes, createRoutesAuth, createRouteShipper, createRoutesShipperLogic } from "src/routes";
import { Switch, Route, Redirect, useHistory } from "react-router-dom";
import { NotFoundScreen } from "src/screens/error/NotFoundScreen";
import { ContextShipper } from "src/context/ContextShipper";
import Cookies from "universal-cookie";
import { ClassificationProvider } from "./provider/ClassificationProvider";
import { FrameProvider } from "./provider/FrameProvider";
import DownloadPage from "src/screens/download";
import { AgreementScreen } from "src/screens/auth/AgreementScreen";

const linkBan = ["/pos", "/order/pre_list", "/product/ads/create"];
const linkBanForChina = ["/product/mass", "/product/mass/list", "/product/mass/detail/:id"];

export function AppRoute() {
  const [shipper, setShipper] = useState({ ship: 0, order: 0 });
  const context = useToken();
  const { merchant } = useContext(ContextUser);
  const routerAuth: ReactNodeArray = [...createRoutesAuth()];
  const sellerRoute: ReactNodeArray = [...createRoutes()];
  const shipperRoute: ReactNodeArray = [...createRoutesShipperLogic()];
  const anonymous = !context.token || !merchant || !merchant.id;

  const [linkCheck, setLinkCheck] = useState<any>(null);

  const { location, listen } = useHistory();
  const cookies = new Cookies();

  useEffect(() => {
    listen((l) => {
      if ([...linkBan, ...linkBanForChina].includes(l.pathname)) {
        setLinkCheck(l.pathname);
      }
    });
  }, [listen]);

  if (linkBan.includes(location.pathname) || linkBan.includes(linkCheck)) {
    return (
      <Page>
        <CalloutCard
          title="Invalid url access"
          illustration="https://cdn.shopify.com/s/assets/admin/checkout/settings-customizecart-705f57c725ac05be5a34ec20c05b94298cb8afd10aac7bd9c7ad02030f48cfa0.svg"
          primaryAction={{ content: "Go to Dashboard", url: "/", external: true }}
          secondaryAction={{
            content: "Logout",
            url: "/",
            onAction: () => {
              cookies.remove("lf_merchant_token");
              context.setToken(null);
              window.location.reload();
            },
            external: true,
          }}
        >
          <p>This url was no longer to access, please go back to dashboard or logout application.</p>
        </CalloutCard>
      </Page>
    );
  }

  // open download page in new tab
  if (location.pathname === "/download") {
    return <DownloadPage />;
  }

  if (location.pathname === "/agreement") {
    return <AgreementScreen />;
  }

  if (anonymous) {
    const x = [location.pathname, linkCheck].filter((f) =>
      ["/update/seller", "/signup", "/verify", "/forget", "/agreement"].includes(f),
    );
    return (
      <Frame>
        <Suspense fallback={<Loading />}>
          <>
            {x.length === 0 && <Redirect path="/" to="/" />}
            <Switch>
              {routerAuth}
              <Route component={NotFoundScreen} />
            </Switch>
          </>
        </Suspense>
      </Frame>
    );
  }

  if (merchant) {
    if (
      merchant.origin === "China" &&
      (linkBanForChina.includes(location.pathname) || linkBanForChina.includes(linkCheck))
    ) {
      return (
        <Page>
          <CalloutCard
            title="Invalid url access"
            illustration="https://cdn.shopify.com/s/assets/admin/checkout/settings-customizecart-705f57c725ac05be5a34ec20c05b94298cb8afd10aac7bd9c7ad02030f48cfa0.svg"
            primaryAction={{ content: "Go to Dashboard", url: "/" }}
            secondaryAction={{
              content: "Logout",
              url: "/",
              onAction: () => {
                cookies.remove("lf_merchant_token");
                context.setToken(null);
                window.location.reload();
              },
            }}
          >
            <p>
              This url was not support in your country to access, please go back to dashboard or logout application.
            </p>
          </CalloutCard>
        </Page>
      );
    }
  }

  return (
    <ClassificationProvider>
      <FrameProvider>
        <Suspense fallback={<Loading />}>
          <div className="all-wrapper with-side-panel solid-bg-all">
            <div className="layout-w">
              {merchant && merchant.role === "SHIPPER" ? (
                <ContextShipper.Provider value={{ shipper, setShipper }}>
                  <Switch>{createRouteShipper()}</Switch>
                </ContextShipper.Provider>
              ) : (
                <>
                  <div className="content-w">
                    <Switch>
                      {merchant.role === "LOGISTIC_SHIPPER"
                        ? shipperRoute
                        : merchant.pos
                          ? sellerRoute
                          : sellerRoute.filter((f: any) => f.key !== "/pos")}
                      <Route component={NotFoundScreen} />
                    </Switch>
                  </div>
                </>
              )}
            </div>
          </div>
        </Suspense>
      </FrameProvider>
    </ClassificationProvider>
  );
}
